import React, { forwardRef, memo } from 'react';
import { withBillingWriteAccess } from 'contexts/adminAccess';
import MenuItem from '@material-ui/core/MenuItem';

const RefundField = forwardRef((props: any, ref: any) => {
  const { record, onRefund, hideAction } = props;

  if (hideAction) {
    return null;
  }

  return (
    <MenuItem ref={ref} onClick={() => onRefund(record)}>
      Refund
    </MenuItem>
  );
});

export default withBillingWriteAccess(memo(RefundField));
